<template>
    <div class="main-page">
        <mobileHeader></mobileHeader>
        <mobileSidebar></mobileSidebar>
        <fixedHeader></fixedHeader>
        <formModal v-if="DomLoaded_one && DomLoaded_two" :class="{open: isOpenFormModal}"></formModal>
        <indexPromo v-if="DomLoaded_one && DomLoaded_two"></indexPromo>
        <about v-if="DomLoaded_one && DomLoaded_two"></about>
        <!-- v-if="DomLoaded" -->
        <formTop v-if="DomLoaded_one && DomLoaded_two"></formTop> 
        <flats v-if="DomLoaded_one && DomLoaded_two"></flats>
        <news :respond.sync="iSmobile"></news>
        <gallery :respond.sync="iSmobile"></gallery>
        <formBottom v-if="DomLoaded_one && DomLoaded_two"></formBottom>
        <contacts></contacts>
        <div class="global-overlay" :class="{'open' : isOpenSendwich, 'open' : isOpenSendwichMobile}" @click="closeMobileMenu(false)">
            <!-- <div class="global-overlay-ripple" :class="{animatedEnd: animatedEnd}"></div> -->
        </div>
    </div>
</template>

<script>
    import indexPromo from '@/components/index-promo/index-promo.vue'
    import about from '@/components/about/about.vue'
    import flats from '@/components/flats/flats.vue'
    import news from '@/components/news/news.vue'
    import gallery from '@/components/gallery/gallery.vue'
    import contacts from '@/components/contacts/contacts.vue'
    import formTop from '@/components/forms/form-top.vue'
    import formBottom from '@/components/forms/form-bottom.vue'
    import formModal from '@/components/forms/form-modal.vue'
    import fixedHeader from '@/components/header-fixed/header-fixed.vue'
    import mobileHeader from '@/components/header/mobile-header.vue'
    import mobileSidebar from '@/components/nav-main/mobile-nav-main.vue'
    export default {
        name: 'main--page',
        components: {
            indexPromo,
            about,
            flats,
            news,
            gallery,
            contacts,
            formTop,
            formBottom,
            fixedHeader,
            formModal,
            mobileHeader,
            mobileSidebar
        },
        data () {
            return {
                // title: 'Главная',
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.25,0.75]
                },
                scrollCounter: false,
                scrollSmallCounter: false,
                DomLoaded_one: false,
                DomLoaded_two: false,
                iSmobile: false,
            }
        },
        computed: {
            isOpenFormModal() {
                return this.$store.state.isOpenFormModal
            },
            isOpenSendwich() {
                return this.$store.state.isOpenSendwich
            },
            isOpenSendwichMobile() {
                return this.$store.state.isOpenSendwichMobile
            },
        },
        methods: {
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            // onWaypoint ({ el, going, direction }) {
            //     if (this.$waypointMap.GOING_IN === going) {
            //         el.classList.add('active');
            //     }
            // },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_sendwich_mobile', data);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            removeLoaderPage() {
                var loader = document.getElementById('loader');
                loader.classList.remove("InitLoader");
                setTimeout(()=>{
                    loader.remove();
                },500);
            }
        },
        beforeCreate() {
        },
        created () {
            // document.title = this.title;
            // window.addEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.isMobileCheck();
            this.checkResize();
            this.$store.watch(
                (state) => state.indexPromo,
                (newValue) => {
                    if (newValue != null) {
                        var _self = this;
                        var image = new Image();
                        var image_two = new Image();
                        image.onload = function () {
                            _self.DomLoaded_one = true;
                            if (_self.DomLoaded_two = true) {
                                _self.removeLoaderPage();
                            }
                            _self.$parent.$refs.topProgress.done();
                        };
                        image_two.onload = function () {
                            _self.DomLoaded_two = true;
                            if (_self.DomLoaded_one = true) {
                                _self.removeLoaderPage();
                            }
                        };
                        image.src = newValue.index_promo_images.img_color;
                        image_two.src = newValue.index_promo_images.img_black;
                    }
                }
            )
        }
    }
</script>